import React from 'react';
import 'flag-icons/css/flag-icons.min.css';

/* ─────────────────────────────────────────────
   Inline data kept separate for easy editing
───────────────────────────────────────────── */
const REVIEWS = [
  { name: "Vishwateja S B", initials: "V", color: "#3b82f6", stars: 5, text: "Best consultancy ever, every process is smooth and secured.", time: "" },
  { name: "Vinayak V Varad", initials: "V", color: "#6366f1", stars: 5, text: "I'm Vinayak from Koppal. Doctor World guided me through every step and helped me get into Bashkir State Medical University, Russia — along with a personal mentor.", time: "2 months ago" },
  { name: "Prajwal M B", initials: "P", color: "#22c55e", stars: 5, text: "It is the best consultancy. The students can fulfil their dreams to become a DOCTOR.", time: "2 months ago" },
  { name: "Амулья Нанда Кишоре", initials: "А", color: "#f97316", stars: 5, text: "Best and affordable consultancy. Expert guidance helped me select the best university. Services from enrollment right until I reached campus. Highly recommend — truly trustworthy.", time: "10 months ago" },
  { name: "Shivu Anagawadi", initials: "S", color: "#14b8a6", stars: 5, text: "A good consultancy that helps students with complete transparency.", time: "2 months ago" },
  { name: "Shriharsh Kotabagi", initials: "S", color: "#f43f5e", stars: 5, text: "Best consultancy — they care like a brother and sister.", time: "2 months ago" },
  { name: "Gaganashree R", initials: "G", color: "#8b5cf6", stars: 5, text: "Best and affordable consultancy with great service. Achieve your MBBS dreams through them.", time: "11 months ago" },
  { name: "Raghav R M", initials: "R", color: "#0ea5e9", stars: 5, text: "Good consultancy for studying abroad.", time: "2 months ago" },
  { name: "Chaithra R", initials: "C", color: "#ec4899", stars: 5, text: "One stop solution for your future. Make your dream come true at an affordable price.", time: "10 months ago" },
  { name: "Hemanth Reddy", initials: "H", color: "#f59e0b", stars: 5, text: "Nice consultancy. Affordable fees and the best services are provided.", time: "11 months ago" },
  { name: "Kiran NM", initials: "K", color: "#10b981", stars: 5, text: "Very good experience with Doctor World.", time: "11 months ago" },
  { name: "Sahana", initials: "S", color: "#d946ef", stars: 5, text: "Amazing experience with Doctor World Consultancy! Truly a top-notch service.", time: "9 months ago" },
  { name: "Legendary 159", initials: "L", color: "#06b6d4", stars: 5, text: "Excellent consultancy services. Highly recommended for medical admissions abroad.", time: "9 months ago" },
  { name: "Prakash Pai", initials: "P", color: "#84cc16", stars: 5, text: "Wonderful consultancy experience. Professional and trustworthy team.", time: "11 months ago" },
  { name: "Yashwanth KN", initials: "Y", color: "#ef4444", stars: 5, text: "Great consultancy! Really helpful in achieving MBBS dreams abroad.", time: "11 months ago" },
  { name: "Ranjith Kumar", initials: "R", color: "#a855f7", stars: 5, text: "Excellent support from Doctor World. They made the entire process of studying abroad very smooth.", time: "11 months ago" },
  { name: "Lavanya Gowda", initials: "L", color: "#eab308", stars: 5, text: "Very good consultancy with excellent services for MBBS abroad.", time: "11 months ago" },
  { name: "Nagesh Nagesh", initials: "N", color: "#3b82f6", stars: 5, text: "Best consultancy for MBBS abroad. Transparent and trustworthy team.", time: "11 months ago" },
  { name: "Sneha M Joseph", initials: "S", color: "#22c55e", stars: 5, text: "Highly recommended consultancy. They helped me throughout the entire admission journey.", time: "11 months ago" },
];

const DESTINATIONS = [
  { name: "Russia", sub: "Top Government Universities", price: "From $3,500/yr", badge: "Top Choice", grad: "linear-gradient(135deg, #2563eb, #06b6d4)", path: "/university-fees?country=Russia", flag: "ru" },
  { name: "Philippines", sub: "US-Based Curriculum", price: "From $4,000/yr", badge: "Popular", grad: "linear-gradient(135deg, #f59e0b, #facc15)", path: "/university-fees?country=Philippines", flag: "ph" },
  { name: "Georgia", sub: "European Standard Education", price: "From $4,500/yr", badge: "European Std", grad: "linear-gradient(135deg, #e11d48, #f43f5e)", path: "/university-fees?country=Georgia", flag: "ge" },
  { name: "Kazakhstan", sub: "Affordable Cost of Living", price: "From $3,000/yr", badge: "Affordable", grad: "linear-gradient(135deg, #059669, #10b981)", path: "/university-fees?country=Kazakhstan", flag: "kz" },
  { name: "Kyrgyzstan", sub: "High FMGE Passing Rate", price: "From $2,800/yr", badge: "5-Year Course", grad: "linear-gradient(135deg, #7c3aed, #a855f7)", path: "/university-fees?country=Kyrgyzstan", flag: "kg" },
  { name: "China", sub: "World-Class Medical Education", price: "From $4,500/yr", badge: "Advanced Tech", grad: "linear-gradient(135deg, #dc2626, #ef4444)", path: "/university-fees?country=China", flag: "cn" },
];

/* ─── tiny SVG helpers ─── */
const ChevronRight = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" /></svg>
);
const StarIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#facc15"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg>
);
const CheckCircle = () => (
  <svg width="20" height="20" fill="none" stroke="#60a5fa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M9 12l2 2 4-4" /></svg>
);
const GoogleG = ({ size = 20 }) => (
  <svg viewBox="0 0 48 48" width={size} height={size}>
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.1l6.8-6.8C35.7 2.5 30.2 0 24 0 14.6 0 6.5 5.5 2.5 13.5l7.9 6.1C12.4 13.1 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17z" />
    <path fill="#FBBC05" d="M10.4 28.4A14.7 14.7 0 019.5 24c0-1.5.3-3 .8-4.4L2.4 13.5A23.9 23.9 0 000 24c0 3.9.9 7.5 2.5 10.7l7.9-6.3z" />
    <path fill="#34A853" d="M24 48c6.2 0 11.4-2 15.2-5.5l-7.5-5.8c-2 1.4-4.6 2.2-7.7 2.2-6.3 0-11.6-4.2-13.5-10l-7.9 6.1C6.5 42.5 14.6 48 24 48z" />
  </svg>
);
const PhoneIcon = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" /></svg>
);
const MailIcon = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M2 7l10 7 10-7" /></svg>
);
const PinIcon = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
);
const WAIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.008-.57-.008-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.359-5.029c0-5.457 4.432-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.16 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.89-11.893 0-3.181-1.238-6.167-3.483-8.412z" /></svg>
);
const EditIcon = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
);

/* ─── glass card style helper ─── */
const glass = (dark, extra = '') =>
  `backdrop-blur-xl border ${dark
    ? 'bg-white/[0.05] border-white/[0.12] '
    : 'bg-white/70 border-white/60 shadow-sm '} ${extra}`;

const HomePage = ({ darkMode: dark }) => {
  const doubleReviews = [...REVIEWS, ...REVIEWS];

  return (
    <div style={{ fontFamily: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif" }}
      className={`min-h-screen overflow-x-hidden ${dark ? 'bg-[#080c14] text-white' : 'bg-gradient-to-br from-slate-100 via-blue-50 to-indigo-100 text-gray-900'}`}>

      {/* ── Keyframes & Font ── */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        @keyframes orb1 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(40px,-30px) scale(1.08)} }
        @keyframes orb2 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(-35px,25px) scale(1.05)} }
        @keyframes orb3 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(20px,40px) scale(1.06)} }
        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes pulse-ring { 0%{transform:scale(1);opacity:.8} 70%{transform:scale(1.7);opacity:0} 100%{transform:scale(1.7);opacity:0} }
        @keyframes reviewScroll { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }

        .orb1 { animation: orb1 9s ease-in-out infinite; }
        .orb2 { animation: orb2 12s ease-in-out infinite; }
        .orb3 { animation: orb3 15s ease-in-out infinite; }
        .fade-up { animation: fadeUp .7s ease both; }
        .pulse-ring { animation: pulse-ring 2s cubic-bezier(.4,0,.6,1) infinite; }
        .reviews-track { display:flex; width:max-content; animation:reviewScroll 50s linear infinite; }
        .reviews-track:hover { animation-play-state:paused; }

        .dest-card:hover .dest-arrow { opacity:1; transform:translateY(0) scale(1); }
        .dest-arrow { opacity:0; transform:translateY(8px) scale(.8); transition:all .3s ease; }

        .service-card:hover { transform:translateY(-4px); }
        .service-card { transition: transform .3s ease, box-shadow .3s ease; }

        @keyframes floatSlideUp {
          from { opacity:0; transform:translateY(20px) scale(.92); }
          to   { opacity:1; transform:translateY(0) scale(1); }
        }
        .float-fab { animation: floatSlideUp .5s cubic-bezier(.34,1.56,.64,1) both; }
      `}</style>

      {/* ── Ambient Orbs (always present, intensity varies by mode) ── */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <div className={`orb1 absolute top-[-15%] left-[-10%] w-[55vw] h-[55vw] rounded-full blur-[130px] ${dark ? 'bg-blue-800/40' : 'bg-blue-300/35'}`} />
        <div className={`orb2 absolute bottom-[-10%] right-[-10%] w-[50vw] h-[50vw] rounded-full blur-[120px] ${dark ? 'bg-indigo-900/35' : 'bg-indigo-200/40'}`} />
        <div className={`orb3 absolute top-[45%] left-[40%] w-[45vw] h-[35vw] rounded-full blur-[110px] ${dark ? 'bg-purple-900/20' : 'bg-purple-200/30'}`} />
      </div>

      {/* ═══════════════════════════════════
          HERO
      ═══════════════════════════════════ */}
      <section className="relative z-10 pt-8 lg:pt-10 pb-16 lg:pb-24 px-5">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center">
          
          {/* Logo */}
          <div className="fade-up mb-4 mt-0" style={{ animationDelay: '0s' }}>
            <img 
              src={dark ? "/logo.png" : "/profile-light.jpeg"}
              alt="Doctor World Consultancy" 
              className={`h-28 md:h-36 lg:h-44 w-auto object-contain transition-all duration-300 ${dark ? 'drop-shadow-2xl' : 'rounded-[2rem] shadow-xl'}`}
            />
          </div>

          {/* Live badge */}
          <div className={`fade-up inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full mb-5 ${glass(dark, 'shadow-lg')}`} style={{ animationDelay: '.05s' }}>
            <span className="relative flex h-2 w-2">
              <span className="pulse-ring absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
            </span>
            <span className={`text-[10px] sm:text-xs uppercase tracking-[0.15em] font-semibold ${dark ? 'text-gray-200' : 'text-gray-600'}`}>
              Admissions Open 2026–27
            </span>
          </div>

          {/* Headline */}
          <h1 className={`fade-up text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight leading-[1.05] mb-4 ${dark ? 'text-white' : 'text-gray-900'}`} style={{ animationDelay: '.1s' }}>
            Your Path to<br />
            <span style={{ background: 'linear-gradient(135deg,#60a5fa,#818cf8,#c084fc)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Becoming a Doctor
            </span>
          </h1>

          <p className={`fade-up text-base md:text-lg leading-relaxed font-light max-w-2xl mx-auto mb-6 ${dark ? 'text-gray-400' : 'text-gray-600'}`} style={{ animationDelay: '.2s' }}>
            Doctor World Consultancy — your trusted partner for premium MBBS abroad admissions, end-to-end guidance, and a smooth path to your medical career.
          </p>

          {/* CTA buttons */}
          <div className="fade-up flex flex-col sm:flex-row items-center justify-center gap-4 mt-2" style={{ animationDelay: '.3s' }}>
            <a href="/student-form"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-base font-bold text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
              style={{ background: 'linear-gradient(135deg, #2563eb, #4f46e5)', boxShadow: '0 10px 25px -5px rgba(59, 130, 246, 0.5)' }}>
              <EditIcon style={{ fontSize: '18px' }} /> Apply Now
            </a>
            <a href="#destinations"
              className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-base font-bold border-2 transition-all duration-300 hover:-translate-y-1 ${
                dark 
                  ? 'border-indigo-400/30 bg-[#0f172a] text-indigo-200 hover:bg-[#1e293b] hover:border-indigo-400/50 hover:text-white shadow-[0_8px_30px_rgba(0,0,0,0.3)]' 
                  : 'border-blue-600 bg-white text-blue-700 hover:bg-blue-50 shadow-[0_10px_30px_rgba(37,99,235,0.15)]'
              }`}>
              Explore Universities <ChevronRight style={{ fontSize: '18px' }} />
            </a>
          </div>

          {/* Stats */}
          <div className="fade-up grid grid-cols-2 md:grid-cols-4 gap-4 mt-20" style={{ animationDelay: '.4s' }}>
            {[
              { val: '30+', label: 'Partner Universities' },
              { val: '550+', label: 'Students Placed' },
              { val: '8+', label: 'Countries' },
              { val: '100%', label: 'Success Rate' },
            ].map(s => (
              <div key={s.label} className={`${glass(dark, 'rounded-3xl')} p-6 text-center group hover:scale-[1.03] transition-transform duration-300`}>
                <div className="text-3xl font-black mb-1" style={{ background: 'linear-gradient(135deg,#60a5fa,#a78bfa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  {s.val}
                </div>
                <div className={`text-sm font-medium ${dark ? 'text-gray-400' : 'text-gray-500'}`}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          SERVICES
      ═══════════════════════════════════ */}
      <section id="services" className="relative z-10 py-24 px-5">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20">
              <p className="text-xs uppercase tracking-widest font-bold text-blue-500">What We Offer</p>
            </div>
            <h2 className="text-4xl md:text-6xl font-black mb-4 tracking-tight"
              style={{ background: 'linear-gradient(135deg, #3b82f6, #6366f1, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Premium Services
            </h2>
            <p className={`text-lg md:text-xl font-medium ${dark ? 'text-gray-300' : 'text-gray-600'}`}>
              End-to-end support designed for your peace of mind.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                icon: <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
                accent: '#60a5fa', bg: 'rgba(96,165,250,0.12)',
                title: 'University Selection',
                desc: 'Personalised matching with top-tier medical institutions based on your budget, NEET score, and academic profile.',
              },
              {
                icon: <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>,
                accent: '#a78bfa', bg: 'rgba(167,139,250,0.12)',
                title: 'Visa & Documentation',
                desc: 'Seamless documentation processing, apostille services, and airport pick-up at your destination.',
              },
              {
                icon: <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>,
                accent: '#f472b6', bg: 'rgba(244,114,182,0.12)',
                title: 'Academic Support',
                desc: 'Pre-departure coaching, FMGE/Next exam preparation, and continuous support throughout your 5–6 year journey.',
              },
            ].map(s => (
              <div key={s.title} className={`service-card ${glass(dark, 'rounded-[2rem] p-8')} group`}>
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
                  style={{ background: s.bg, color: s.accent }}>
                  {s.icon}
                </div>
                <h3 className={`text-xl font-bold mb-3 ${dark ? 'text-white' : 'text-gray-900'}`}>{s.title}</h3>
                <p className={`text-sm leading-relaxed ${dark ? 'text-gray-400' : 'text-gray-500'}`}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          DESTINATIONS
      ═══════════════════════════════════ */}
      <section id="destinations" className="relative z-10 py-24 px-5">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-purple-500/10 border border-purple-500/20">
              <p className="text-xs uppercase tracking-widest font-bold text-purple-500">Study Abroad</p>
            </div>
            <h2 className="text-4xl md:text-6xl font-black mb-4 tracking-tight"
              style={{ background: 'linear-gradient(135deg, #a855f7, #6366f1, #3b82f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Global Destinations
            </h2>
            <p className={`text-lg md:text-xl font-medium ${dark ? 'text-gray-300' : 'text-gray-600'}`}>
              Study in countries renowned for medical excellence.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {DESTINATIONS.map(d => (
              <a key={d.name} href={d.path} className="dest-card block relative overflow-hidden rounded-[2rem] h-80 cursor-pointer group border border-white/10">
                {/* Full gradient background */}
                <div className="absolute inset-0 opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ background: d.grad }} />
                {/* Dark scrim */}
                <div className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors duration-300" />
                {/* Content layout */}
                <div className="absolute inset-0 p-8 flex flex-col justify-between">
                  {/* Top row: badge + hover arrow */}
                  <div className="flex justify-between items-start">
                    <span className="px-3 py-1 bg-white/25 backdrop-blur-md rounded-full text-xs font-semibold border border-white/20 text-white">
                      {d.badge}
                    </span>
                    <div className="dest-arrow w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-white border border-white/20">
                      <ChevronRight />
                    </div>
                  </div>
                  {/* Bottom: country name, subtitle, price */}
                  <div>
                    <h3 className="text-3xl flex items-center gap-3 font-bold mb-2 text-white">
                      <span className={`fi fi-${d.flag} rounded-sm overflow-hidden text-2xl drop-shadow-md`} />
                      {d.name}
                    </h3>
                    <p className="text-white/80 text-sm mb-4">{d.sub}</p>
                    <div className="inline-block px-4 py-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/20 text-sm font-semibold text-white">
                      {d.price}
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          WHY CHOOSE US + PROCESS
      ═══════════════════════════════════ */}
      <section id="process" className="relative z-10 py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className={`text-3xl md:text-5xl font-bold mb-6 ${dark ? 'text-white' : 'text-gray-900'}`}>Why High-Achievers Choose Doctor World.</h2>
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <svg className="w-6 h-6 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span className={`text-lg ${dark ? 'text-gray-300' : 'text-gray-700'} font-light`}>100% Transparent Fee Structure</span>
                </div>
                <div className="flex items-center gap-4">
                  <svg className="w-6 h-6 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span className={`text-lg ${dark ? 'text-gray-300' : 'text-gray-700'} font-light`}>Direct partnerships with Universities</span>
                </div>
                <div className="flex items-center gap-4">
                  <svg className="w-6 h-6 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span className={`text-lg ${dark ? 'text-gray-300' : 'text-gray-700'} font-light`}>MCI/NMC & WHO Recognized Colleges</span>
                </div>
                <div className="flex items-center gap-4">
                  <svg className="w-6 h-6 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span className={`text-lg ${dark ? 'text-gray-300' : 'text-gray-700'} font-light`}>Separate Hostels for Indian Students</span>
                </div>
                <div className="flex items-center gap-4">
                  <svg className="w-6 h-6 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span className={`text-lg ${dark ? 'text-gray-300' : 'text-gray-700'} font-light`}>Next/FMGE Exam Coaching Included</span>
                </div>
              </div>
              <a href="#contact" className="inline-block mt-10 px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full font-medium shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40 transition-all text-white">
                Start Your Journey
              </a>
            </div>

            {/* Visual Glass Element */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-500 to-purple-500 rounded-[2.5rem] blur-2xl opacity-20"></div>
              <div className={`relative ${dark ? 'bg-white/5 border-white/10' : 'bg-white/80 border-gray-200'} backdrop-blur-xl border rounded-[2.5rem] p-8 md:p-12`}>
                <div className="space-y-6">
                  <div className="flex items-center gap-4 mb-8">
                    <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-400 font-bold">1</div>
                    <div>
                      <h4 className={`font-semibold text-lg ${dark ? 'text-white' : 'text-gray-900'}`}>Consultation</h4>
                      <p className={`text-sm ${dark ? 'text-gray-400' : 'text-gray-600'}`}>Profile analysis & free counseling</p>
                    </div>
                  </div>
                  <div className={`w-px h-8 ${dark ? 'bg-white/10' : 'bg-gray-300'} ml-6 -my-2`}></div>
                  <div className="flex items-center gap-4 mb-8">
                    <div className="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center text-purple-400 font-bold">2</div>
                    <div>
                      <h4 className={`font-semibold text-lg ${dark ? 'text-white' : 'text-gray-900'}`}>Documentation</h4>
                      <p className={`text-sm ${dark ? 'text-gray-400' : 'text-gray-600'}`}>Admission letter & Apostille</p>
                    </div>
                  </div>
                  <div className={`w-px h-8 ${dark ? 'bg-white/10' : 'bg-gray-300'} ml-6 -my-2`}></div>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center text-green-400 font-bold">3</div>
                    <div>
                      <h4 className={`font-semibold text-lg ${dark ? 'text-white' : 'text-gray-900'}`}>Departure</h4>
                      <p className={`text-sm ${dark ? 'text-gray-400' : 'text-gray-600'}`}>Visa stamping & Group Travel</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          GOOGLE REVIEWS REEL
      ═══════════════════════════════════ */}
      <section id="testimonials" className="relative z-10 py-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 mb-14 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <GoogleG size={32} />
            <h2 className={`text-3xl md:text-5xl font-bold ${dark ? 'text-white' : 'text-gray-900'}`}>Google Reviews</h2>
          </div>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} />)}
            <span className={`ml-2 text-sm font-semibold ${dark ? 'text-gray-300' : 'text-gray-700'}`}>5.0 · 18 reviews</span>
          </div>
          <p className={`text-sm ${dark ? 'text-gray-500' : 'text-gray-400'}`}>What our students say on Google Maps</p>
        </div>

        {/* Edge fades */}
        <div className={`absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none ${dark ? 'bg-gradient-to-r from-[#080c14] to-transparent' : 'bg-gradient-to-r from-slate-100 to-transparent'}`} />
        <div className={`absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none ${dark ? 'bg-gradient-to-l from-[#080c14] to-transparent' : 'bg-gradient-to-l from-indigo-100 to-transparent'}`} />

        <div className="overflow-hidden">
          <div className="reviews-track">
            {doubleReviews.map((r, idx) => (
              <div key={idx}
                className={`flex-shrink-0 w-72 md:w-80 mx-3 p-6 rounded-[1.75rem] flex flex-col ${glass(dark, 'hover:scale-[1.02] transition-transform duration-300')}`}
                style={{ minHeight: 220 }}>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white text-sm shrink-0"
                      style={{ background: r.color }}>
                      {r.initials}
                    </div>
                    <div>
                      <p className={`font-semibold text-sm leading-tight ${dark ? 'text-white' : 'text-gray-900'}`}>{r.name}</p>
                      {r.time && <p className={`text-xs ${dark ? 'text-gray-500' : 'text-gray-400'}`}>{r.time}</p>}
                    </div>
                  </div>
                  <GoogleG size={22} />
                </div>
                <div className="flex gap-0.5 mb-3">{[...Array(r.stars)].map((_, i) => <StarIcon key={i} />)}</div>
                <p className={`text-sm leading-relaxed line-clamp-4 flex-1 ${dark ? 'text-gray-300' : 'text-gray-600'}`}>"{r.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          CONTACT CTA
      ═══════════════════════════════════ */}
      <section id="contact" className="relative z-10 py-24 px-5">
        <div className="max-w-4xl mx-auto">
          <div className={`relative overflow-hidden rounded-[3rem] p-8 md:p-16 text-center ${glass(dark)}`}
            style={{ boxShadow: dark ? '0 24px 80px rgba(99,102,241,0.15)' : '0 24px 60px rgba(99,102,241,0.10)' }}>

            {/* Deco orbs inside card */}
            <div className="absolute top-0 right-0 w-72 h-72 rounded-full blur-[90px]" style={{ background: 'rgba(99,102,241,0.18)' }} />
            <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full blur-[90px]" style={{ background: 'rgba(168,85,247,0.15)' }} />

            <div className="relative z-10">
              <p className="text-xs uppercase tracking-widest font-semibold text-blue-400 mb-4">Get Started Today</p>
              <h2 className={`text-3xl md:text-5xl font-bold mb-5 ${dark ? 'text-white' : 'text-gray-900'}`}>
                Ready to Wear the<br />White Coat?
              </h2>
              <p className={`mb-10 max-w-md mx-auto leading-relaxed ${dark ? 'text-gray-300' : 'text-gray-600'}`}>
                Book a free counselling session with our senior experts. Seats are limited for the 2026 intake.
              </p>

              <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center mb-10">
                {/* Phone */}
                <a href="tel:+919845298192"
                  className={`inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-2xl font-semibold transition-all hover:scale-[1.03] ${glass(dark, 'hover:bg-white/10')}`}>
                  <PhoneIcon /> +91 98452 98192
                </a>
                {/* WhatsApp */}
                <a href="https://wa.me/919845298192" target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-2xl font-semibold text-white transition-all hover:scale-[1.03] hover:shadow-xl"
                  style={{ background: '#25D366', boxShadow: '0 6px 24px rgba(37,211,102,0.35)' }}>
                  <WAIcon /> WhatsApp
                </a>
                {/* Email */}
                <a href="mailto:doctorworldconsultancy@gmail.com"
                  className={`inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-2xl font-semibold transition-all hover:scale-[1.03] ${glass(dark, 'hover:bg-white/10')}`}>
                  <MailIcon /> Email Us
                </a>
              </div>

              <div className={`flex items-center justify-center gap-2 text-sm ${dark ? 'text-gray-500' : 'text-gray-400'}`}>
                <PinIcon />
                <span>Teachers Colony beside Church, Mulbagal 563131, Kolar District</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          FLOATING BUTTONS (always visible)
      ═══════════════════════════════════ */}
      <div className="fixed bottom-6 right-5 z-50 flex flex-col gap-3 items-end">
        {/* Phone */}
        <a href="tel:+919845298192"
          className="float-fab inline-flex items-center gap-2 px-4 py-3 rounded-full text-white text-sm font-semibold transition-all duration-200 hover:scale-105"
          style={{ background: '#0284c7', boxShadow: '0 6px 24px rgba(2,132,199,0.45)' }}>
          <PhoneIcon /> Call Now
        </a>
        {/* WhatsApp */}
        <a href="https://wa.me/916364249519" target="_blank" rel="noopener noreferrer"
          className="float-fab inline-flex items-center gap-2 px-4 py-3 rounded-full text-white text-sm font-semibold transition-all duration-200 hover:scale-105"
          style={{ background: '#25D366', boxShadow: '0 6px 24px rgba(37,211,102,0.45)' }}>
          <WAIcon /> WhatsApp
        </a>
        {/* Apply Now */}
        <a href="/student-form"
          className="float-fab inline-flex items-center gap-2 px-5 py-3 rounded-full text-white text-sm font-semibold transition-all duration-200 hover:scale-105"
          style={{ background: 'linear-gradient(135deg,#3b82f6,#6366f1)', boxShadow: '0 6px 24px rgba(99,102,241,0.45)' }}>
          <EditIcon /> Apply Now
        </a>
      </div>

    </div>
  );
};

export default HomePage;
